var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSr = function SvgIconSr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M23.254 7.827H.746A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.174h22.508c.482-1.3.746-2.706.746-4.174s-.264-2.874-.746-4.174"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6DA544"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.035 24.001c4.11 0 7.737-2.067 9.9-5.217h-19.8a11.99 11.99 0 0 0 9.9 5.217M12.035 0c4.11 0 7.737 2.067 9.9 5.218h-19.8A11.99 11.99 0 0 1 12.035 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m12 7.827 1.035 3.188h3.353l-2.713 1.971 1.036 3.189L12 14.205l-2.712 1.97 1.036-3.189-2.713-1.97h3.353z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconSr;